import PostHog from 'posthog-js'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  let posthog: any

  //if (config.public.name === 'alpha') {
  if (true) {
    posthog = PostHog.init(config.public.POSTHOG_API_KEY, {
      api_host: 'https://eu.i.posthog.com',
    })
  } else {
    // Define a dummy posthog object
    posthog = {
      capture: () => {},
      identify: () => {},
      people: {
        set: () => {},
      },
      reset: () => {},
      opt_out_capturing: () => {},
      opt_in_capturing: () => {},
      isFeatureEnabled: () => false,
      onFeatureFlags: () => {},
      getFeatureFlag: () => null,
    }
  }

  // Inject posthog to the context as $posthog
  nuxtApp.provide('posthog', posthog)
})
